import { Button, Text } from '@usap/uicomponents'
import styled from 'styled-components'

export const ShowMoreButton = styled(Button)`
  height: 46px;
  padding: 0 16px;
  margin: auto;
  fill: #2e4787;
    &:hover {
      fill: #fff!important;
    }
`

export const StyledLinkBox = styled.div`
  margin: 4px;
  padding: 8px;
  border: solid 1px #e0e0e0;
  display: flex;
  line-height: 20px;
  align-items: center;
  text-align: center;
  justify-content: center;
  flex-grow: 1;
  background-color: #fff;
  ${({ theme }) => theme.mediaQuery.up('large')} {
    margin: 8px;
    padding: 16px;
  }
  &:hover {
    border: solid 1px #f5f5f5;
    span {
      color: #05629b;
    }
  }
`
